<template>
  <div class="func-search-gallery-top">
    <a v-on:click="clickLink()" class="btn btn-default btn-lg" role="button">
      <slot></slot>
    </a>
  </div>
</template>

<script>
export default {
  name: 'FuncSearchGalleryTop',
  methods: {
    clickLink: function () {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "gallery_top"
      })

      if(this.$route.path !== '/' + this.$store.state.lg2 + '/'){
        this.$router.push({ 
          path: '/' + this.$store.state.lg2 + '/',
          query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
